import { useState } from 'react';

import { Icon } from '@ui-component-library/components/Icon';

import type { TermsCheckboxProps } from './TermsCheckbox.types';

import { S } from './TermsCheckbox.styles';

export const TermsCheckbox = ({
  defaultChecked = false,
  onClick,
  name = 'terms-checkbox',
  label = 'Terms and Conditions',
  isValid,
  errorText,
  tabIndex = 0
}: TermsCheckboxProps) => {
  console.warn(
    `The "TermsCheckbox" component is deprecated. Please use the "Checkbox" component instead.`,
    `See stories for examples.`
  );
  const [checked, setChecked] = useState(defaultChecked);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = e.target.checked;
    setChecked(newChecked);
    onClick(newChecked, newChecked, name);
  };

  return (
    <S.Wrapper htmlFor={name} tabIndex={tabIndex}>
      <S.CheckboxWrapper>
        <S.HiddenCheckbox
          $checked={checked}
          id={name}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
        />
        <S.CustomCheckbox $checked={checked}>
          {checked && <Icon name="CheckSimple" size="medium" color="white-50" />}
        </S.CustomCheckbox>
        <S.Label>{label}</S.Label>
      </S.CheckboxWrapper>

      <S.ErrorWrapper>
        {isValid === false && (
          <>
            <Icon name="ExclamationFilled" size="medium" color="danger-500" />
            <S.ErrorText>{errorText}</S.ErrorText>
          </>
        )}
      </S.ErrorWrapper>
    </S.Wrapper>
  );
};
